import dayjs from "dayjs";

export const dateStringFormatPrinter = (dateString: string | null, format?: string): string => {
  if (dateString === null) {
    return "";
  }

  return dayjs(dateString).format(format || "DD/MM/YYYY");
};

// date object to string, format DD/MM/YYYY
export const dateToString = (date: Date | null): string => {
  if (!date) {
    return "";
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
